import { deepMerge } from 'js/utils/Utils'
import { getTargetOffsetTop } from 'js/utils/Utils'
import { clamp, lerp, roundEx } from 'js/utils/Maths'
import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'homeFirstScrollProgressAnimation',
  $names: {
    title: '[data-parallax-item="home-intro-title"]',
    p: '[data-parallax-item="home-intro-p"]',
    maskIn: '.mask_in',
  },
  effectInfo: {
    titleLerpFactor: 0.3,
    pLerpFactor: 0.3,
  },
}

export default class HomeFirstScrollProgressAnimation {
  $contentRoot = document
  $titles = []
  $ps = []

  scrollInfo = {
    titles: [],
    ps: [],
  }

  wh = 0

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this._setScrollInfo()
    this._setPositions()
    this._addHandlers()
  }

  destroy() {
    this._removeHandlers()
  }

  _set$() {
    this.$titles = this.$contentRoot.querySelectorAll(this.$names.title)
    this.$ps = this.$contentRoot.querySelectorAll(this.$names.p)
  }

  _addHandlers() {
    if (Common.raf) {
      Common.raf.addHandler(() => {
        this.onRaf()
      }, this.instanceName)
    }

    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, this.instanceName)
    }
  }

  _removeHandlers() {
    if (Common.raf) {
      Common.raf.removeHandler(this.onRaf, this.instanceName)
    }

    if (Common.resize) {
      Common.resize.removeHandler(this.onResize, this.instanceName)
    }
  }

  _setScrollInfo() {
    this.scrollInfo.titles = []
    this.scrollInfo.ps = []

    this.$titles.forEach(($title) => {
      const $maskIns = $title.querySelectorAll(this.$names.maskIn)
      if ($title) {
        const rect = $title.getBoundingClientRect()
        const offsetTop = getTargetOffsetTop($title)
        this.scrollInfo.titles.push({
          $title: $title,
          $maskIns: $maskIns,
          height: rect.height,
          offsetTop: offsetTop,
          start: 0,
          end: 0,
          progress: 0,
          progressLerp: 0,
        })
      }
    })

    this.$ps.forEach(($p) => {
      const offsetTop = getTargetOffsetTop($p)
      this.scrollInfo.ps.push({
        $p: $p,
        height: 0,
        offsetTop: offsetTop,
        start: 0,
        end: 0,
        progress: 0,
        progressLerp: 0,
      })
    })
  }

  _setPositions() {
    this.wh = window.innerHeight

    this.scrollInfo.titles.forEach((info) => {
      if (info.$title) {
        info.height = info.$title.getBoundingClientRect().height
        info.offsetTop = getTargetOffsetTop(info.$title)
        info.start = info.offsetTop + info.height - this.wh
        // info.end = info.offsetTop - this.wh + this.wh * 0.5 + info.height * 0.5
        info.end = info.offsetTop - this.wh + this.wh * 0.5
      }
    })

    this.scrollInfo.ps.forEach((info) => {
      if (info.$p) {
        const rect = info.$p.getBoundingClientRect()
        info.height = rect.height
        info.offsetTop = getTargetOffsetTop(info.$p)
        info.start = info.offsetTop - this.wh + this.wh * 0.15
        info.end = info.offsetTop - this.wh + this.wh * 0.5
      }
    })
  }

  _setScrollEffects() {
    this.scrollInfo.titles.forEach((info) => {
      if (info.$maskIns) {
        const currentScroll = Common.scroll.currentScroll - info.start
        info.progress = currentScroll / (info.end - info.start)
        info.progress = clamp(info.progress, 0, 1)

        info.progressLerp = lerp(info.progressLerp, info.progress, this.effectInfo.titleLerpFactor / Common.raf.fpsMultiplier)

        // info.progressLerp = clamp(info.progress, 0, 1)
        info.progressLerp = roundEx(info.progressLerp, 1000)

        let translate = 100 - info.progress * 100
        translate = roundEx(translate, 1000)

        info.$maskIns.forEach(($maskIn) => {
          $maskIn.style.transform = `translate(0, ${translate}%) rotate(0.001deg)`
        })
      }
    })

    this.scrollInfo.ps.forEach((info) => {
      if (info.$p) {
        const currentScroll = Common.scroll.currentScroll - info.start
        info.progress = currentScroll / (info.end - info.start)

        info.progressLerp = lerp(info.progressLerp, info.progress, this.effectInfo.pLerpFactor / Common.raf.fpsMultiplier)

        info.progressLerp = clamp(info.progress, 0, 1)
        info.progressLerp = roundEx(info.progressLerp, 1000)

        info.$p.style.opacity = info.progressLerp
      }
    })
  }

  onResize() {
    this._setPositions()
  }

  onRaf() {
    this._setScrollEffects()
  }
}